import translator from '@/locales';

const statusMap = {
  not_started: 'ADVERTISEMENT.CAMPAIGNS.NOT_STARTED',
  ended: 'ADVERTISEMENT.CAMPAIGNS.ENDED',
  paused: 'ADVERTISEMENT.CAMPAIGNS.PAUSED',
  active: 'ADVERTISEMENT.CAMPAIGNS.ACTIVE',
  no_budget: 'ADVERTISEMENT.CAMPAIGNS.NO_BUDGET',
  reached_daily_cap: 'ADVERTISEMENT.CAMPAIGNS.RECHED_DAILY_CAP',
  low_budget: 'ADVERTISEMENT.CAMPAIGNS.LOW_BUDGET',
};

// todo: remove the other codes later
function translateCampaignStatusV2(status) {
  if (status in statusMap) {
    return translator.t(statusMap[status]);
  }

  return status;
}

export { translateCampaignStatusV2 as translateCampaignStatus };

export default function translateCampaignStatus(status) {
  if (status in statusMap) {
    return statusMap[status];
  }

  return '';
}
